/**
 * Given ANY valid SKU (including a parent SKU), return the parent SKU
 * @param sku
 */
export const getAncestorSku = (sku: string): string => {
  // Inventory SKUs have the general format IJVCA2042X001
  const inventorySkuParts = sku.split('X');
  // This accounts for if the brand has an X in it
  const inventorySku = inventorySkuParts
    .slice(0, inventorySkuParts.length - 1)
    .join('X');

  // Sized SKUs have the general format IJCA65090N001X002
  const sizedSkuParts = inventorySku ? inventorySku.split('N') : sku.split('N');
  // This accounts for if the brand has an N in it
  const skuWithoutSizeSuffix = sizedSkuParts
    .slice(0, sizedSkuParts.length - 1)
    .join('N');

  // Ensure prefixed with a P for parent product
  const ancestorSku = `P${skuWithoutSizeSuffix.slice(1)}`;

  return ancestorSku;
};
